import dynamic from "next/dynamic";

const Image = dynamic(() => import("../Image"));
const Text = dynamic(() => import("../Text"));
const Video = dynamic(() => import("../Video"));

export function resolveContentBlocks(contentBlock) {
  let Component = null;

  switch (contentBlock._type) {
    case "contentBlockImage":
      Component = Image;
      break;
    case "contentBlockText":
      Component = Text;
      break;
    case "contentBlockVideo":
      Component = Video;
      break;
    default:
      Component = null;
      break;
  }

  if (Component) {
    return Component;
  }

  return null;
}